import React from 'react'
import { If, Then, Else } from 'react-if'
import { FieldErrors, Controller } from 'react-hook-form'
import {
  Autocomplete as AutoCompleteComponent,
  CircularProgress
} from '@mui/material'

import { CustomInput } from '../Input/styles'
import { Row, Span } from 'components'
import { COLORS, SPACING } from 'utils'

interface IAutoCompleteProps {
  noFilter?: boolean
  control?: any
  errors?: FieldErrors
  defaultValue?: any
  formValue?: string
  label?: string
  maxLength?: number
  options: object[]
  optionLabel: string
  placeholder?: string
  onChangeText?: (_event: React.ChangeEvent<HTMLInputElement>) => void
  loading?: boolean
  optionValue?: string
  disabled?: boolean
  onChange?: (_event: React.ChangeEvent<HTMLInputElement>, value: any) => void
  value?: unknown
  name?: string
  onSelect?: (selectedValue: unknown) => void
}

const AutoCompleteSearchTerm: React.FC<IAutoCompleteProps> = ({
  control,
  errors,
  formValue,
  label,
  maxLength,
  options,
  optionLabel,
  optionValue,
  placeholder,
  onChangeText,
  loading,
  defaultValue,
  onChange,
  value,
  name,
  disabled,
  noFilter,
  onSelect
}) => {
  const hasError = errors ? errors[formValue] : null

  const getValue = (controlValue: unknown) => {
    if (controlValue) {
      if (optionValue && options?.length) {
        return options.find((option) => option[optionValue] === controlValue)[
          optionLabel
        ]
      }

      return controlValue[optionLabel]
    }

    return ''
  }

  return (
    <If condition={Boolean(control)}>
      <Then>
        <Controller
          control={control}
          name={formValue}
          defaultValue={defaultValue}
          render={({
            field: { onChange: controlOnChange, value: controlValue }
          }) => (
            <AutoCompleteComponent
              filterOptions={noFilter ? (option) => option : undefined}
              onChange={(_, selectedValue) => {
                if (optionValue && selectedValue) {
                  controlOnChange(selectedValue[optionValue])
                } else {
                  controlOnChange(selectedValue)
                }

                if (onSelect) {
                  onSelect(selectedValue)
                }
              }}
              value={getValue(controlValue)}
              disabled={disabled}
              options={
                options.length > 0
                  ? options?.map((option) => ({
                      ...option,
                      label: option[optionLabel]
                    }))
                  : []
              }
              renderInput={(params) => (
                <>
                  <CustomInput
                    {...params}
                    label={label}
                    hasError={!!hasError}
                    error={!!hasError}
                    placeholder={placeholder}
                    variant="standard"
                    onChange={onChangeText}
                    inputProps={{ ...params.inputProps, maxLength: maxLength }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading && (
                            <CircularProgress color="inherit" size={20} />
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      )
                    }}
                  />
                  {!!hasError && (
                    <Row marginTop={SPACING.spacing5}>
                      <Span
                        text={errors[formValue]?.message || 'Erro'}
                        color={COLORS.error}
                      />
                    </Row>
                  )}
                </>
              )}
            />
          )}
        />
      </Then>

      <Else>
        <AutoCompleteComponent
          onChange={onChange}
          value={value}
          disabled={disabled}
          options={
            options.length > 0
              ? options?.map((option) => ({
                  ...option,
                  label: option[optionLabel]
                }))
              : []
          }
          renderInput={(params) => (
            <>
              <CustomInput
                {...params}
                name={name}
                label={label}
                hasError={!!hasError}
                error={!!hasError}
                placeholder={placeholder}
                variant="standard"
                onChange={onChangeText}
                inputProps={{ ...params.inputProps, maxLength: maxLength }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && (
                        <CircularProgress color="inherit" size={20} />
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }}
              />
              {!!hasError && (
                <Row marginTop={SPACING.spacing5}>
                  <Span
                    text={errors[formValue]?.message || 'Erro'}
                    color={COLORS.error}
                  />
                </Row>
              )}
            </>
          )}
        />
      </Else>
    </If>
  )
}

export default AutoCompleteSearchTerm
